import { render, staticRenderFns } from "./GoogleReviewPromoCard.vue?vue&type=template&id=493149d4&"
import script from "./GoogleReviewPromoCard.vue?vue&type=script&lang=js&"
export * from "./GoogleReviewPromoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports